import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCard } from '@angular/material/card';
import {
  ShipmentInfoListTableComponent,
  ShipmentViewModel,
} from '../shipment-info-list-table/shipment-info-list-table.component';

@Component({
  selector: 'app-shipment-info-in-progress',
  standalone: true,
  imports: [CommonModule, MatCard, ShipmentInfoListTableComponent],
  templateUrl: './shipment-info-in-progress.component.html',
  styleUrl: './shipment-info-in-progress.component.scss',
})
export class ShipmentInfoInProgressComponent {
  @Input({ required: true }) public shipmentList: ShipmentViewModel[] = [];
  @Input() public routeLoading = false;
  @Input() public defaultFilters: { [key: string]: string | boolean | number } =
    {};
  @Input() public editableRole = false;

  @Output() public opened = new EventEmitter<ShipmentViewModel>();
  @Output() public statusGottenReady = new EventEmitter<string>();
  @Output() public statusInterrupted = new EventEmitter<string>();
}
